import React from "react"
import PropTypes from "prop-types"
import lottie from 'lottie-web'


class SearchBar extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      text: ''
    }
    this.onChange = this.onChange.bind(this)
  }

  componentDidMount() {
    lottie.loadAnimation({
      container: document.getElementById('search'),
      renderer: 'svg',
      loop: true,
      autoplay: false,
      name: 'search',
      path: this.props.searchLottie
    });
    lottie.pause()
  }

  onChange(event) {
    this.props.updateSearchText(event.target.value)
    lottie.play('search')
    lottie.pause('search')
  }

  render() {
      return(
        <div className="exchangesPage__searchWrap">
          <input
            className="exchangesPage__searchInput"
            type="search"
            placeholder="Search activities..."
            onChange={this.onChange}
            value={this.props.searchText}
            aria-label="Search activities"
          />
          <div id="search" className="exchangesPage__searchLottie" aria-hidden="true" />
        </div>
      )
  }
}

export default SearchBar;
